/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AsyncQueueFullRepresentation,
  AsyncTicketCreatedRepresentation,
  ChartDataRequest,
  GaugeDataRequest,
  PieDataRequest,
  PowercurveDataRequest,
  ScatterDataRequest,
} from '../models/index';
import {
    AsyncQueueFullRepresentationFromJSON,
    AsyncQueueFullRepresentationToJSON,
    AsyncTicketCreatedRepresentationFromJSON,
    AsyncTicketCreatedRepresentationToJSON,
    ChartDataRequestFromJSON,
    ChartDataRequestToJSON,
    GaugeDataRequestFromJSON,
    GaugeDataRequestToJSON,
    PieDataRequestFromJSON,
    PieDataRequestToJSON,
    PowercurveDataRequestFromJSON,
    PowercurveDataRequestToJSON,
    ScatterDataRequestFromJSON,
    ScatterDataRequestToJSON,
} from '../models/index';

export interface StartChartDataAsCSVAsyncRequest {
    chartDataRequest: ChartDataRequest;
}

export interface StartChartDataAsyncRequest {
    chartDataRequest: ChartDataRequest;
}

export interface StartGaugeDataAsyncRequest {
    gaugeDataRequest: GaugeDataRequest;
}

export interface StartPieDataAsyncRequest {
    pieDataRequest: PieDataRequest;
}

export interface StartPowercurveDataAsyncRequest {
    powercurveDataRequest: PowercurveDataRequest;
}

export interface StartScatterDataAsyncRequest {
    scatterDataRequest: ScatterDataRequest;
}

/**
 * 
 */
export class AsyncDataApi extends runtime.BaseAPI {

    /**
     * Enqueues a chart CSV export request and returns a ticket for polling the result
     * Start async chart CSV export
     */
    async startChartDataAsCSVAsyncRaw(requestParameters: StartChartDataAsCSVAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AsyncTicketCreatedRepresentation>> {
        if (requestParameters['chartDataRequest'] == null) {
            throw new runtime.RequiredError(
                'chartDataRequest',
                'Required parameter "chartDataRequest" was null or undefined when calling startChartDataAsCSVAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/csv/chart/async`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChartDataRequestToJSON(requestParameters['chartDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AsyncTicketCreatedRepresentationFromJSON(jsonValue));
    }

    /**
     * Enqueues a chart CSV export request and returns a ticket for polling the result
     * Start async chart CSV export
     */
    async startChartDataAsCSVAsync(chartDataRequest: ChartDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AsyncTicketCreatedRepresentation> {
        const response = await this.startChartDataAsCSVAsyncRaw({ chartDataRequest: chartDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Enqueues a chart data request and returns a ticket for polling the result
     * Start async chart data retrieval
     */
    async startChartDataAsyncRaw(requestParameters: StartChartDataAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AsyncTicketCreatedRepresentation>> {
        if (requestParameters['chartDataRequest'] == null) {
            throw new runtime.RequiredError(
                'chartDataRequest',
                'Required parameter "chartDataRequest" was null or undefined when calling startChartDataAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/chart/async`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChartDataRequestToJSON(requestParameters['chartDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AsyncTicketCreatedRepresentationFromJSON(jsonValue));
    }

    /**
     * Enqueues a chart data request and returns a ticket for polling the result
     * Start async chart data retrieval
     */
    async startChartDataAsync(chartDataRequest: ChartDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AsyncTicketCreatedRepresentation> {
        const response = await this.startChartDataAsyncRaw({ chartDataRequest: chartDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Enqueues a gauge data request and returns a ticket for polling the result
     * Start async gauge data retrieval
     */
    async startGaugeDataAsyncRaw(requestParameters: StartGaugeDataAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AsyncTicketCreatedRepresentation>> {
        if (requestParameters['gaugeDataRequest'] == null) {
            throw new runtime.RequiredError(
                'gaugeDataRequest',
                'Required parameter "gaugeDataRequest" was null or undefined when calling startGaugeDataAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/gauge/async`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GaugeDataRequestToJSON(requestParameters['gaugeDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AsyncTicketCreatedRepresentationFromJSON(jsonValue));
    }

    /**
     * Enqueues a gauge data request and returns a ticket for polling the result
     * Start async gauge data retrieval
     */
    async startGaugeDataAsync(gaugeDataRequest: GaugeDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AsyncTicketCreatedRepresentation> {
        const response = await this.startGaugeDataAsyncRaw({ gaugeDataRequest: gaugeDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Enqueues a pie data request and returns a ticket for polling the result
     * Start async pie data retrieval
     */
    async startPieDataAsyncRaw(requestParameters: StartPieDataAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AsyncTicketCreatedRepresentation>> {
        if (requestParameters['pieDataRequest'] == null) {
            throw new runtime.RequiredError(
                'pieDataRequest',
                'Required parameter "pieDataRequest" was null or undefined when calling startPieDataAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/pie/async`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PieDataRequestToJSON(requestParameters['pieDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AsyncTicketCreatedRepresentationFromJSON(jsonValue));
    }

    /**
     * Enqueues a pie data request and returns a ticket for polling the result
     * Start async pie data retrieval
     */
    async startPieDataAsync(pieDataRequest: PieDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AsyncTicketCreatedRepresentation> {
        const response = await this.startPieDataAsyncRaw({ pieDataRequest: pieDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Enqueues a powercurve data request and returns a ticket for polling the result
     * Start async powercurve data retrieval
     */
    async startPowercurveDataAsyncRaw(requestParameters: StartPowercurveDataAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AsyncTicketCreatedRepresentation>> {
        if (requestParameters['powercurveDataRequest'] == null) {
            throw new runtime.RequiredError(
                'powercurveDataRequest',
                'Required parameter "powercurveDataRequest" was null or undefined when calling startPowercurveDataAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/powercurve/async`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PowercurveDataRequestToJSON(requestParameters['powercurveDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AsyncTicketCreatedRepresentationFromJSON(jsonValue));
    }

    /**
     * Enqueues a powercurve data request and returns a ticket for polling the result
     * Start async powercurve data retrieval
     */
    async startPowercurveDataAsync(powercurveDataRequest: PowercurveDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AsyncTicketCreatedRepresentation> {
        const response = await this.startPowercurveDataAsyncRaw({ powercurveDataRequest: powercurveDataRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Enqueues a scatter data request and returns a ticket for polling the result
     * Start async scatter data retrieval
     */
    async startScatterDataAsyncRaw(requestParameters: StartScatterDataAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AsyncTicketCreatedRepresentation>> {
        if (requestParameters['scatterDataRequest'] == null) {
            throw new runtime.RequiredError(
                'scatterDataRequest',
                'Required parameter "scatterDataRequest" was null or undefined when calling startScatterDataAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/data/scatter/async`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScatterDataRequestToJSON(requestParameters['scatterDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AsyncTicketCreatedRepresentationFromJSON(jsonValue));
    }

    /**
     * Enqueues a scatter data request and returns a ticket for polling the result
     * Start async scatter data retrieval
     */
    async startScatterDataAsync(scatterDataRequest: ScatterDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AsyncTicketCreatedRepresentation> {
        const response = await this.startScatterDataAsyncRaw({ scatterDataRequest: scatterDataRequest }, initOverrides);
        return await response.value();
    }

}
